/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_SourceInputs */

const en_gc_home_source = /** @type {(inputs: Gc_Home_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the official open-source project`)
};

const zh_gc_home_source = /** @type {(inputs: Gc_Home_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看官方开源项目`)
};

/**
* | output |
* | --- |
* | "Explore the official open-source project" |
*
* @param {Gc_Home_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_source = /** @type {((inputs?: Gc_Home_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_source(inputs)
	return zh_gc_home_source(inputs)
});
export { gc_home_source as "gc.home.source" }